/** @jsxImportSource theme-ui */
import React, { useState } from 'react';
import { Box, Flex, Heading } from 'theme-ui';
import Button from '@/components/Button';
import { PreviewColorScheme, useWidgetPreview } from './useWidgetPreview';

interface Props {
    configuration: Record<string, unknown> | null;
    companySitepath: string;
    embedScriptUrl: string;
    onClose?: () => void;
    fitViewport?: boolean;
}

const WidgetPreviewPane: React.FC<Props> = ({ configuration, companySitepath, embedScriptUrl, onClose, fitViewport }) => {
    const [scheme, setScheme] = useState<PreviewColorScheme>('light');
    const mountWidget = useWidgetPreview(configuration, companySitepath, embedScriptUrl, scheme, fitViewport);

    return (
        <Box sx={{ position: 'sticky', top: '1em', display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 2em)' }}>
            <Flex sx={{ alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Heading as="h4" sx={{ m: 0 }}>Preview</Heading>
                <Flex sx={{ gap: 2, alignItems: 'center' }}>
                    <Button
                        type="button"
                        variant={scheme === 'light' ? 'primary' : 'secondary'}
                        onClick={() => setScheme('light')}
                    >
                        Light
                    </Button>
                    <Button
                        type="button"
                        variant={scheme === 'dark' ? 'primary' : 'secondary'}
                        onClick={() => setScheme('dark')}
                    >
                        Dark
                    </Button>
                    {onClose && (
                        <Button type="button" variant="secondary" onClick={onClose}>
                            Close
                        </Button>
                    )}
                </Flex>
            </Flex>
            <Box
                key={`${scheme}-${fitViewport}`}
                ref={mountWidget}
                sx={{
                    flex: 1,
                    minHeight: fitViewport ? '800px' : '700px',
                    overflowY: 'auto',
                    border: '1px solid',
                    borderColor: 'gray.3',
                    borderRadius: 'sm',
                }}
            />
        </Box>
    );
};

export default WidgetPreviewPane;
